/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Debitornummer_Type_NumberInputs */



/**

* @param {Debitornummer_Type_NumberInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const debitornummer_type_number = /** @type {((inputs?: Debitornummer_Type_NumberInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Debitornummer_Type_NumberInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Die Debitorennummer muss vom Typ Zahl sein.")
});